import { render, staticRenderFns } from "./PayrollDashboardDetail2.vue?vue&type=template&id=5ed7553c&scoped=true"
import script from "./PayrollDashboardDetail2.vue?vue&type=script&lang=js"
export * from "./PayrollDashboardDetail2.vue?vue&type=script&lang=js"
import style0 from "./PayrollDashboardDetail2.vue?vue&type=style&index=0&id=5ed7553c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed7553c",
  null
  
)

export default component.exports